module.exports = __webpack_public_path__ + "static/media/fre-1.0c9c5356.jpg";